module.exports = __webpack_public_path__ + "img/inventario.9c4de4b4.png";